import { createReducer } from "@reduxjs/toolkit"
import { setCurrentUser } from "../actions"
import { User } from "../app/types"

export const currentUser = createReducer<User>(null, (builder) => {
    builder.addCase(setCurrentUser, (_, action) => action.payload)
})
